import * as React from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import InputLabel from '@material-ui/core/InputLabel';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme, createStyles, Input, CircularProgress, LinearProgress } from '@material-ui/core';
import { AccountBoxOutlined } from '@material-ui/icons'
import { withToast, WithToast } from '../HOC/Toast';
import strings from '../../strings';
import GlobalStyle from '../GlobalStyles';
import { UsersAPI, getDefaultDevice, Session } from 'src/api'
import { withRouter, RouteComponentProps } from 'react-router';
import { } from '../HOC/Transition';
import KDInput from '../Input/Input';
import WelcomeHeader from '../Header/WelcomeHeader';
import KDGlobal from '../Global';
interface SignUpState {
    errors: {
        name?: boolean,
        email?: boolean,
        password?: boolean,
        accept?: boolean
    }
    loading: boolean
    name: string;
    email: string;
    password: string;
    password_repeat: string;
    terms_accepted: boolean;
}

class SignUp extends React.Component<WithStyles<typeof styles, true> & RouteComponentProps & WithToast, SignUpState> {

    constructor(props: WithStyles<typeof styles, true> & RouteComponentProps & WithToast) {
        super(props);
        this.state = {
            errors: {},
            loading: false,
            name: '',
            email: '',
            password: '',
            password_repeat: '',
            terms_accepted: false
        }
    }

    private onSignupClick() {
        if (!this.state.name) {
            this.props.showToast('error', strings.error_provideName)
            this.setState({ errors: { name: true } })
        } else if (this.state.name.split(' ').length < 2) {
            this.props.showToast('error', strings.error_provideName)
            this.setState({ errors: { name: true } })
        } else if (!this.state.email) {
            this.props.showToast('error', strings.error_provideEmail)
            this.setState({ errors: { email: true } })
        } else if (this.state.email.indexOf('@') === -1) {
            this.props.showToast('error', strings.error_invalidEmail)
            this.setState({ errors: { email: true } })
        } else if (!this.state.password) {
            this.props.showToast('error', strings.error_providePassword)
            this.setState({ errors: { password: true } })
        } else if (this.state.password.length < 6) {
            this.setState({ errors: { password: true } })
            this.props.showToast('error', strings.error_passwordNotMeetingRequirement)
        } else if (this.state.password != this.state.password_repeat) {
            this.setState({ errors: { password: true } })
            this.props.showToast('error', strings.error_passwordNotMatch)
        } else if (!this.state.terms_accepted) {
            this.props.showToast('error', strings.error_acceptTC)
            this.setState({ errors: { accept: true } })
        } else {
            this.setState({ loading: true })
            getDefaultDevice(false, window.navigator.language).then(data => {
                UsersAPI.signUp(this.state.email, this.state.password, this.state.name, data).then(device => {
                    KDGlobal.instance.setUser(device.user, device)
                    this.props.history.push('/verify')
                }).catch(err => {
                    let message = err.message
                    if (err.invalid_keys) {
                        message = Object.keys(err.invalid_keys).map(k => {
                            return err.invalid_keys[k]
                        }).join('\n')
                    } else if (err.error && err.error.type == 'ResourceAlreadyExists') {
                        message = strings.error_emailAlreadyExisting
                    }
                    this.props.showToast('error', message)
                    this.setState({ loading: false })
                })
            })
        }
    }

    public render() {
        const { classes } = this.props;

        return <>
            <WelcomeHeader />
            <main className={classes.main}>
                <CssBaseline />
                <Paper className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <AccountBoxOutlined />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        {strings.sign_up}
                    </Typography>
                    <form className={classes.form}>
                        <FormControl margin="normal" fullWidth>
                            <InputLabel htmlFor="name">{strings.fullName}</InputLabel>
                            <KDInput error={this.state.errors.name} id="name" name="name"
                                onEnterKey={this.onSignupClick.bind(this)}
                                autoComplete="name" autoFocus value={this.state.name}
                                onChange={(e) => this.setState({ name: e.target.value })} />
                        </FormControl>
                        <FormControl margin="normal" fullWidth>
                            <InputLabel htmlFor="email">{strings.emailAddress}</InputLabel>
                            <KDInput error={this.state.errors.email} id="email" type="email" name="email"
                                onEnterKey={this.onSignupClick.bind(this)}
                                autoComplete="email" value={this.state.email}
                                onChange={(e) => this.setState({ email: e.target.value })} />
                        </FormControl>
                        <FormControl margin="normal" fullWidth>
                            <InputLabel htmlFor="password">{strings.password}</InputLabel>
                            <KDInput error={this.state.errors.password} name="password" type="password" id="password"
                                onEnterKey={this.onSignupClick.bind(this)}
                                autoComplete="current-password" value={this.state.password}
                                onChange={(e) => this.setState({ password: e.target.value })} />
                        </FormControl>
                        <FormControl margin="normal" fullWidth>
                            <InputLabel htmlFor="password">{strings.sign_up_repeatPassword}</InputLabel>
                            <KDInput error={this.state.errors.password} name="password-reapet" type="password" id="password-reapet"
                                onEnterKey={this.onSignupClick.bind(this)}
                                autoComplete="reapet-password" value={this.state.password_repeat}
                                onChange={(e) => this.setState({ password_repeat: e.target.value })} />
                        </FormControl>
                        <FormControlLabel
                            control={<Checkbox value="accept" color="primary"
                                checked={this.state.terms_accepted}
                                onChange={(e) => this.setState({ terms_accepted: e.target.checked })} />}
                            label={<a className={classes.link} onClick={() => this.props.history.push('/toc')}>{strings.sign_up_accept_tc}</a>}
                        />
                        <div style={GlobalStyle(this.props.theme).wrapper as React.CSSProperties}>
                            <Button
                                fullWidth
                                disabled={this.state.loading}
                                variant="contained"
                                color="primary"
                                onClick={this.onSignupClick.bind(this)}
                                className={classes.submit}>
                                {strings.sign_up}
                            </Button>
                        </div>
                    </form>
                    {this.state.loading && <CircularProgress variant={'indeterminate'} size={24} className={classes.loader} />}
                </Paper>
            </main>
        </>
    }
}

const styles = (theme: Theme) => createStyles(({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing(3),
        marginRight: theme.spacing(3),
        [theme.breakpoints.up(400 + theme.spacing(3) * 2)]: {
            width: 400,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    link: {
        color: theme.palette.text.primary
    },
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing(2)}px ${theme.spacing(3)}px ${theme.spacing(3)}px`,
    },
    loader: {
        marginTop: theme.spacing()
    },
    avatar: {
        margin: theme.spacing(),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(),
    },
    submit: {
        marginTop: theme.spacing(3),
    },
}));

export default (withStyles(styles, { withTheme: true })(withRouter(withToast(SignUp))));


// WEBPACK FOOTER //
// ./src/components/SignUp/SignUp.tsx